import "./NetworkConnection.css";
import { useEffect, useState } from "react";

const NetworkConnection = () => {
  const [isConnected, setIsConnected] = useState(true);

  useEffect(() => {
    window.onoffline = () => {
      setIsConnected(false);
    };
    window.ononline = () => {
      setIsConnected(true);
    };
  }, []);

  if (isConnected) return;

  return <div className="network-connection">No Internet Connection</div>;
};

export default NetworkConnection;
